DialogController = App.loadClass "core::Angular/DialogController"
Treatment = App.loadClass "portal::Angular/Ratings/Models/Treatment"

class exports.TreatmentDialogController extends DialogController

    constructor: (@scope, @transitions, @repo, @modalInstance, lineups_id, treatment) ->
        super(@scope, @transitions, @modalInstance)

        # empty model for editing within the scope of this dialog
        t = new Treatment()

        if treatment?
            @scope.treatment = $.extend t, treatment # copy existing model
            @scope.title = 'Edit Treatment'
        else
            @scope.treatment = t # use the empty model
            @scope.title = 'Add Treatment'

        @scope.absolute_errors = false

        @lineups_id = lineups_id

    save: =>
        promise = @repo.saveTreatment(@lineups_id, @scope.treatment).then (response) =>
            if response.status?.type
                @closeWithAlert response.status, response.data, false

        .catch (response) =>
            @closeWithAlert(type: 'error', msg: 'Failed to save treatment')

        return promise
